import React, { FC, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';
import { useSetAtom as useSetStateSegment, useAtom as useSegment } from 'jotai';
import styles from './MainLayout.module.css';
import NavigationPanel from '../../widgets/NavigationPanel';
import { isNavPanelOpenStateSegment } from '../../../store/markettingContentGeneration/stateSegments/genaiConfigStateSegment';
import { knowledgeCenterModalAtom } from '../../../store/markettingContentGeneration/stateSegments/knowledgeCenterModalStateSegment';
import KnowledgeCenterIcon from '../../atoms/KnowledgeCenterIcon';
import ModalComponent from '../../molecules/ModalComponent';
import KnowledgeCenter from '../../widgets/KnowledgeCenter';
import ImageGenerationFields from '../../widgets/ImageGeneration/index';
import { ImageGenerationModalAtom } from '../../../store/markettingContentGeneration/stateSegments/ImageGenerationModalStateSegment';
type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isNavPanelOpen = get(location, 'state.isNavPanelOpen', false);
  const setIsPanelOpen = useSetStateSegment(isNavPanelOpenStateSegment);

  const [isNavOpen, setIsNavOpen] = useState(isNavPanelOpen);
  const [activeMenu, setActiveMenu] = useState('');

  const [knowledgeCenterModalState, setKnowledgeCenterModalState] = useSegment(
    knowledgeCenterModalAtom
  );

  const { isKnowledgeCenterModalOpen } = knowledgeCenterModalState;
  const [ImageGenerationModalState, setImageGenerationModalState] = useSegment(
    ImageGenerationModalAtom
  );

  const { isImageGenerationModalOpen } = ImageGenerationModalState;

  useEffect(() => {
    setIsPanelOpen(isNavPanelOpen);
  }, []);

  const handleNavMenuToggle = useCallback((value: boolean) => {
    setIsNavOpen(value);
    setIsPanelOpen(value);
  }, []);

  return (
    <>
      <div className={styles['page-layout__wrapper']}>
        <div className={styles['page-layout__col-left']}>
          <NavigationPanel
            isExpanded={isNavOpen}
            onNavToggle={handleNavMenuToggle}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
          />
        </div>
        <div className={styles['page-layout__col-right']}>
          <div
            id='top-nav'
            className={
              isNavOpen
                ? styles['top-nav--expanded']
                : styles['top-nav--collapsed']
            }
          />
          <div
            className={`${styles['app-main']} ${
              isNavOpen
                ? styles['app-main--expanded']
                : styles['app-main--collapsed']
            }`}
          >
            {children}
          </div>
        </div>
      </div>
      {isKnowledgeCenterModalOpen && (
        <ModalComponent
          className={styles.knowledgeCenterModal}
          isOpen={isKnowledgeCenterModalOpen}
          onClose={() => {
            setKnowledgeCenterModalState(prev => ({
              ...prev,
              isKnowledgeCenterModalOpen: false,
            }));
          }}
          title='Knowledge Center'
          headerIcon={<KnowledgeCenterIcon />}
          leftOffset={isNavOpen ? 260 : 80}
          headerStyle={styles.knowledgeCenterModal__header}
        >
          <KnowledgeCenter />
        </ModalComponent>
      )}
      {isImageGenerationModalOpen && (
        <ModalComponent
          className={styles.knowledgeCenterModal}
          isOpen={isImageGenerationModalOpen}
          onClose={() => {
            setImageGenerationModalState(prev => ({
              ...prev,
              isImageGenerationModalOpen: false,
            }));
          }}
          title='Image Generation'
          headerIcon={<KnowledgeCenterIcon />}
          leftOffset={isNavOpen ? 260 : 80}
          headerStyle={styles.knowledgeCenterModal__header}
        >
          <ImageGenerationFields />
        </ModalComponent>
      )}
    </>
  );
};

MainLayout.displayName = 'MainLayout';
export default MainLayout;
